import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateBeforeCallDetail } from '../../../../actions/waitingArea.js';
import { updateShowWaitingAreaBeforeCallsModal } from '../../../../actions/modal.js';

export default function RightPanelTop(props) {
  const dispatch = useDispatch();
  const [updatingBeforeCallsDetail, setUpdatingBeforeCallsDetail] = useState(false);

  const updateBeforeCallDetailWithInComponent = () => {
    setUpdatingBeforeCallsDetail(true);
    let beforeCallDetail = props.beforeCallsForm;
    let cb = () => {
      setUpdatingBeforeCallsDetail(false);
      dispatch(updateShowWaitingAreaBeforeCallsModal(false));
    };
    dispatch(updateBeforeCallDetail(props.waitingArea.id, beforeCallDetail, cb));
  };

  const saveModalChange = (event) => {
    if (!window.$(event.target).hasClass('disable')) {
      updateBeforeCallDetailWithInComponent();
    }
  };

  const cancelUpdateBeforeCalls = () => {
    dispatch(updateShowWaitingAreaBeforeCallsModal(false));
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="ui actions mrbl max-width">
          <button
            tabIndex="4"
            type="button"
            data-group="updatewaitingAreaForm"
            onClick={updateBeforeCallDetailWithInComponent}
            className={updatingBeforeCallsDetail ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark  icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={cancelUpdateBeforeCalls}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="ui actions mrbl max-width mrtxxs ">
          <button
            onClick={cancelUpdateBeforeCalls}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
}
